import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "input-group mb-3 px-4 text-dark" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "row pb-4"
}
const _hoisted_6 = { class: "col col-12" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", null, "GoodRx vs. IntelligentRx Drug Price Comparisons", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "Search or click on a drug below to see both the GoodRx and the IntelligentRx price for the drug's most common form, dosage, and quantity. These drug price comparisons were used to generate the IntelligentRx vs. GoodRx comparison statistics you see above.", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "search",
          class: "form-control text-start",
          placeholder: $options.placeHolder,
          style: {"font":"var(--body-font-weight) 16px/19px var(--body-font-family)"},
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.drugSearch) = $event))
        }, null, 8, _hoisted_4), [
          [_vModelText, $data.drugSearch]
        ])
      ])
    ]),
    ($data.drugSearch != null && $data.drugSearch != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.drugSearchResults, (result) => {
              return (_openBlock(), _createElementBlock("div", {
                key: result.drugName
              }, [
                _createElementVNode("a", {
                  href: result.link,
                  style: {"text-transform":"capitalize"}
                }, _toDisplayString(result.drugName), 9, _hoisted_7)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}